module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/domofon-2-a839a8f004482b6b7710bac031f21169.png";